const serializeLabel = rawLabel => rawLabel.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase();

module.exports = { serializeLabel };
